import { render, staticRenderFns } from "./TheAost.vue?vue&type=template&id=237c6c58&scoped=true&"
import script from "./TheAost.vue?vue&type=script&lang=js&"
export * from "./TheAost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237c6c58",
  null
  
)

export default component.exports